import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { AdminService } from "../../services/admin.service";

@Component({
  standalone: false,
  selector: "app-loader",
  templateUrl: "./loader.component.html",
  styleUrls: ["./loader.component.css"],
})
export class LoaderComponent implements OnInit {
  spinner;
  constructor(
    private admin: AdminService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.admin.loaderState.subscribe((data) => {
      setTimeout(() => {
        this.spinner = !!data;
        this.cdr.detectChanges();
      });
    });
  }
}
